/* eslint-disable */
import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    MODAL_SHOW_EDIT_BENEFICIARY: "beneficiary/MODAL_SHOW_EDIT_BENEFICIARY",
    MODAL_CLOSE_EDIT_BENEFICIARY: "beneficiary/MODAL_CLOSE_EDIT_PBENEFICIARY",
    LOAD_CATALOGUES: "beneficiary/LOAD_CATALOGUES",
    CLEAR_LOAD_CATALOGUES: "beneficiary/CLEAR_LOAD_CATALOGUES",
    CLEAR_CANCELLED_MODAL: "beneficiary/CLEAR_CANCELLED_MODAL",
}

export const INITIAL_STATE = {
    displayModalEdit: false,
    idBeneficiary: null,
    loadCatalogues: false,
    cancelledModal: false,
};


export default createReducer(INITIAL_STATE, {
    [types.MODAL_SHOW_EDIT_BENEFICIARY]: (state, { idBeneficiary }) => ({
        ...state,
        displayModalEdit: true,
        idBeneficiary,
        cancelledModal: false,
    }),
    [types.MODAL_CLOSE_EDIT_BENEFICIARY]: (state) => ({
        ...state,
        displayModalEdit: false,
        idBeneficiary: null,
        cancelledModal: true,
    }),
     [types.CLEAR_CANCELLED_MODAL]: (state) => ({
        ...state,
        cancelledModal: false,
    }),
    [types.LOAD_CATALOGUES]: (state) => ({
        ...state,
        loadCatalogues: true,
    }),
    [types.CLEAR_LOAD_CATALOGUES]: (state) => ({
        ...state,
        loadCatalogues: false,
    })
});

export const actions = {
    modalEditShow: makeActionCreator(types.MODAL_SHOW_EDIT_BENEFICIARY, "idBeneficiary"),
    modalEditHide: makeActionCreator(types.MODAL_CLOSE_EDIT_BENEFICIARY),
    loadBeneficiaryCatalogues: makeActionCreator(types.LOAD_CATALOGUES),
    clearLoadCatalogues: makeActionCreator(types.CLEAR_LOAD_CATALOGUES),
    clearCancelledModal : makeActionCreator(types.CLEAR_CANCELLED_MODAL),
}

export const selectors = {
    getDisplayModalEditBeneficiary: ({ beneficiary }) => beneficiary?.displayModalEdit,
    getIdBeneficiary: ({beneficiary}) => beneficiary?.idBeneficiary,
    getLoadCatalogues: ({beneficiary}) => beneficiary?.loadCatalogues,
    isCancelledModal: ({beneficiary}) => beneficiary?.cancelledModal,
}